import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvCheckListHdrModel } from '../../../../../models/aggregates/asv/asv-checklist-hdr.model';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../api-services';

@Injectable({
    providedIn: 'root'
  })

  export class AsvChecklistHdrService extends BaseApiTemplateService<AsvCheckListHdrModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'checklist-hdrs';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'checklist-hdrs/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'checklist-hdrs/backoffice-ep';
        this.httpClient = http;
      }
}